import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useRef, useState } from "react";
import { TextField, InputAdornment } from "@mui/material";

const Input: FC<Props> = ({
  type = "input",
  variant = "filled",
  name = "",
  label,
  onChange,
  defaultValue,
  value,
  placeholder,
  disabled = false,
  onBlur,
  onFocus,
  isError,
  className = "",
  Icon,
}) => {
  const ref = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [text, setText] = useState(defaultValue ?? "");
  const [shrink, setShrink] = useState(false);

  return (
    <div className={styles.wrap}>
      <TextField
        autoComplete="off"
        size="small"
        label={label}
        onFocus={() => setShrink(true)}
        onBlur={(e) => setShrink(!!e.target.value)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={isError}
        slotProps={{
          inputLabel: {
            sx: {
              ml: Icon ? 4.5 : 0,
            },
            shrink: shrink,
          },
          input: {
            startAdornment: Icon ? (
              <InputAdornment position="start">{Icon}</InputAdornment>
            ) : undefined,
          },
        }}
        style={{
          width: "100%",
          // height: height,
        }}
        sx={{
          "& .MuiFilledInput-notchedOutline": {
            px: 5.5,
          },
          "& .MuiInputAdornment-root": {
            marginTop: "0 !important",
          },
          "& .MuiInputLabel-outlined.MuiInputLabel-shrink ": {
            marginLeft: "0 !important",
          },
        }}
        variant={variant}
        color="primary"
      />
    </div>
  );
};

export default Input;
